import { connect } from 'react-redux';
import RekapJadwal from '../../views/Settings/RekapJadwal.view';
import { getClasses, getParamOptionsAcademics, getPrmLevels, getPeriodsOptions, getSchoolUnitsOptions, getPrmLevelRecap, getSemesterOptions } from '../../states/thunks/options.thunk';
import { listScheduleSubject, deleteScheduleSubject, listReportSchedule, getListScheduleSubject, generateSchedule, getTotalJP, getNotesUnpostingSch, listRekapJadwal} from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleListScheduleSubject: (payload, goback) => dispatch(listScheduleSubject(payload, goback)),
    handleListReportSchedule: (payload, goback) => dispatch(listReportSchedule(payload, goback)),
    handleDeleteScheduleSubject: (payload, goback) => dispatch(deleteScheduleSubject(payload, goback)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    handleGetScheduleSubject: payload => dispatch(getListScheduleSubject(payload)),
    handleGenerateSchedule: payload => dispatch(generateSchedule(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    handleGetJp: payload => dispatch(getTotalJP(payload)),
    getNotesUnpostingSch: payload => dispatch(getNotesUnpostingSch(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getPrmLevelRecap: payload => dispatch(getPrmLevelRecap(payload)),
    handleListRekapJadwal: payload => dispatch(listRekapJadwal(payload)),
    getSemesterOptions: payload => dispatch(getSemesterOptions(payload))

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RekapJadwal);
